import LoggedOutNavigation from "@/components/navigation/common/LoggedOutNavigation";

// OTP pages render outside AppStateProvider (see OtpGate), so avoid B2CHeader/HeaderProvider.
export default function AuthFlowHeader() {
  return <LoggedOutNavigation />;
}
